<div class="sub-footer dark-subfooter">
  <div id="sub-footer" class="container">
    <div class="row">
      <!-- @if(data?.footer?.footer_copyright){
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                  <app-footer-copyright [data]="data"></app-footer-copyright>
                                </div>
                                } -->
      <div class="col-xl-6 col-md-6 col-sm-12">
        @if (copyright && copyright.visible) {
          <div class="footer-end">
            <p>
              <i class="fa fa-copyright" aria-hidden="true"></i>
              {{ copyright.value }}
            </p>
          </div>
        }
      </div>
      <!-- @if(data?.footer?.payment_option_image_url){
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                  <div class="payment-card-bottom">
                                    <app-footer-payment-options [data]="data"></app-footer-payment-options>
                                  </div>
                                </div>
                                } -->
      <div class="col-xl-6 col-md-6 col-sm-12">
        <div class="payment-card-bottom">
          @if (paymentOption && paymentOption.visible) {
            <img
              [src]="paymentOption.value"
              [alt]="paymentOption.alt"
              [title]="paymentOption.title"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
